import { PictureDTO } from "./picture.dto";

export class RsvpDTO{
    id: number;
    email: string = ''
    firstName: string = ''
    lastName: string = ''
    profilePicUrl: PictureDTO;
    deleted: boolean = false;

    constructor(data: Partial<RsvpDTO> = {}){
        for(let key in data){
            if(key === 'profilePicUrl'){
                this[key] = new PictureDTO(data[key]);
            }else{
                this[key] = data[key];
            }
        }
    }
}